import React from 'react';
import { CellContext } from '@tanstack/table-core';
import { Moment } from 'moment';

import { Typography } from '../../../../Typography';

export interface IDateCellProps {
    cell: CellContext<any, Moment | null | undefined>;
}

export const DateCell = ({ cell }: IDateCellProps) => {
    const value = cell.getValue();
    if (!value) {
        return null;
    }

    return <Typography>{value.format('D. M. YYYY')}</Typography>;
};
